import React, { useState, useEffect } from 'react';
import { Button, ListGroup } from 'react-bootstrap';
import { postDocsByIds } from '../../services';
import Loading from '../DocList/Loading';
import DocCardMitreAttack from './DocCardMitreAttack';

const MitreRelationship = ({ source, target, profile }) => {
  const [isLoadingMore, setIsLoadingMore] = useState({});
  const [content, setContent] = useState([]);
  const fields = [
    'title',
    'url',
    'text',
    'publishDate',
    'modified',
    'objectType',
    'x_mitre_aliases',
    'x_mitre_attack_spec_version',
    'x_mitre_platforms',
  ];
  useEffect(() => {
    setIsLoadingMore(true);
    postDocsByIds(profile, [source, target], fields).then((res) => {
      if (res.status === 200 && res.documents) {
        setContent(res.documents);
      }
    });
  }, []);

  return (
    <div className='mitre-relationshiop'>
      {content && content.length ? (
        <>
          {content.map((doc) => {
            if (doc.objectType !== 'relationship')
              return (
                <DocCardMitreAttack
                  doc={doc}
                  showAddWatchList={profile.roles.indexOf('curator') > -1}
                  list='watchlist'
                  showRemove={profile.roles.indexOf('curator') > -1}
                  profilePrimary={profile}
                  profileSecondary={null}
                  key={doc.id}
                />
              );
            return null;
          })}
        </>
      ) : null}
    </div>
  );
};

export default MitreRelationship;
